/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";

export const KillswitchCapabilityKey = {
  McpToolCalls: "mcp_tool_calls",
} as const;
export type KillswitchCapabilityKey = OpenEnum<typeof KillswitchCapabilityKey>;

/** @internal */
export const KillswitchCapabilityKey$inboundSchema: z.ZodMiniType<
  KillswitchCapabilityKey,
  unknown
> = openEnums.inboundSchema(KillswitchCapabilityKey);
/** @internal */
export const KillswitchCapabilityKey$outboundSchema: z.ZodMiniType<
  string,
  KillswitchCapabilityKey
> = openEnums.outboundSchema(KillswitchCapabilityKey);
